// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__293HT","breadcrumb__no-bg":"Breadcrumb_breadcrumb__no-bg__2r0NE"};